import React from 'react';
import { useTranslation } from 'react-i18next';
import * as Sentry from '@sentry/react';
import FallbackScreen from './FallbackScreen';

const ErrorBoundary = ({ children }) => {
  const { t, i18n } = useTranslation('common');

  const dialogOptions = {
    lang: i18n.language,
    title: t('errorBoundary.form.title'),
    labelName: t('errorBoundary.form.labelName'),
    labelSubmit: t('errorBoundary.form.labelSubmit'),
    labelComments: t('errorBoundary.form.labelComments'),
    errorFormEntry: t('errorBoundary.form.errorFormEntry')
  };

  return (
    <Sentry.ErrorBoundary fallback={({ error }) => <FallbackScreen error={error} />} showDialog dialogOptions={dialogOptions}>
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default ErrorBoundary;
